var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-config-block",class:{
    'theme-config-block--no-preview': !_vm.preview,
  }},[_c(_vm.themeConfigBlockType.component,{ref:"themeConfigBlockForm",tag:"component",attrs:{"preview":_vm.preview,"theme":_vm.theme,"extra-args":_vm.extraArgs,"default-values":_vm.defaultValues},on:{"values-changed":function($event){return _vm.$emit('values-changed', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }